import React, { createContext, useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import AuthenticationService from '../Api/AuthenticationService';


export const AuthContext = createContext();

const AuthObject = new AuthenticationService();

export const AuthProvider = ({ children }) => {
    //  const navigate = useNavigate();
    const [data, setData] = useState({
        user: null,
        auth: false,
        priviledge: ''
    });
    
    const [authData, setAuthData] = useState(null);
    const [authentication, setAuthentication] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies([
        'email', 
        'RoleName',
        'id', 
        'username', 
        'employeename', 
        'token',
        'remembered_number',
        'remembered_password',
        'KAPPU', 
        'KAPPP'
    ]);


    const login = async (authenticationData) => {
        try {
            const response = await AuthObject.VerifyOtp2(authenticationData);
            const responseData = response.data;

            if (response.status === 200 && responseData.status === "success") {
                // Store token in localStorage
                if (responseData.data.token && typeof responseData.data.token === 'string') {
                    localStorage.setItem("token", responseData.data.token);
                }

                // Update auth data
                setAuthData(authenticationData);
                
                // Update user data
                setData({
                    user: responseData.data.user,
                    auth: true,
                    priviledge: responseData.data.user.role
                });

                // Set cookies with proper validation
                if (responseData.data.user) {
                    const user = responseData.data.user;
                    setCookie('email', user.email || '', { path: "/" });
                    setCookie('id', user.id || '', { path: "/" });
                    setCookie('username', user.full_name || '', { path: "/" });
                    setCookie('employeename', user.full_name || '', { path: "/" });
                    setCookie('RoleName', user.role || '', { path: "/" });
                    setCookie('token', responseData.data.token || '', { path: "/" });
                }
                
                setAuthentication(true);
                return true;
            }
            return false;
        } catch (error) {
            console.error('Login error:', error);
            return false;
        }
    };

    const rememberCredentials = (number, password) => {
        // Set cookies with 30 days expiration
        setCookie('remembered_number', number, { 
            path: "/",
            maxAge: 30 * 24 * 60 * 60 // 30 days
        });
        setCookie('remembered_password', password, { 
            path: "/",
            maxAge: 30 * 24 * 60 * 60 // 30 days
        });
    };

    const getRememberedCredentials = () => {
        return {
            number: cookies.remembered_number || '',
            password: cookies.remembered_password || ''
        };
    };

    const clearRememberedCredentials = () => {
        removeCookie('remembered_number');
        removeCookie('remembered_password');
    };

    const logout = () => {
        // Clear states
        setAuthentication(false);
        setAuthData(null);
        setData({
            user: null,
            auth: false,
            priviledge: ''
        });
        
        // Clear all cookies
        removeCookie('userName');
        removeCookie('roleName');
        removeCookie('employeeName');
        removeCookie('token');
        removeCookie('userID');
        removeCookie('emailID');
        removeCookie('id');
        removeCookie('KAPPP');
        removeCookie('KAPPU');
        //clearRememberedCredentials();
    };

    return (
        <AuthContext.Provider value={{ 
            data, 
            cookies, 
            authentication, 
            authData,
            setAuthData,
            setCookie, 
            login, 
            logout, 
            removeCookie, 
            setData,
            rememberCredentials,
            getRememberedCredentials,
            clearRememberedCredentials
        }}>
            {children}
        </AuthContext.Provider>
    );
}